import React from "react";

const HeaderSection = () => {
  return (
    <div id="header-section">
      <div className="marquee">
        <div className="marquee__item">
          **** NEUROSYNAPTIC MINDFUSION WITH{" "}
          <span className="leo-name">LEO</span> INITIATED **** TELEPATHIC USER
          PORTALS LINKED **** NEURAL INTERFACE CALIBRATION COMPLETE ****
          CEREBRAL CORTEX COMMAND CENTERS ONLINE **** AI SENTIENT ASSISTANTS ON
          STANDBY **** HOLO-MUSIC VISUALIZERS READY **** BRAINWAVE BEAT MAPPING
          ACTIVE **** CEREBRO-SYNC CONCERTS ALWAYS **** HACKING INTO THE SWAG
          MONEY METAVERSE "SMM"{" "}
          <span className="leo-name">WE'RE NOT LEAVING</span>{" "}
        </div>
        <div className="marquee__item">
          **** NEUROSYNAPTIC MINDFUSION WITH{" "}
          <span className="leo-name">LEO</span> INITIATED **** TELEPATHIC USER
          PORTALS LINKED **** NEURAL INTERFACE CALIBRATION COMPLETE ****
          CEREBRAL CORTEX COMMAND CENTERS ONLINE **** AI SENTIENT ASSISTANTS ON
          STANDBY **** HOLO-MUSIC VISUALIZERS READY **** BRAINWAVE BEAT MAPPING
          ACTIVE **** CEREBRO-SYNC CONCERTS ALWAYS **** HACKING INTO THE SWAG
          MONEY METAVERSE "SMM"{" "}
          <span className="leo-name">WE'RE NOT LEAVING</span>{" "}
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
